// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aj","header":"ak","title":"al","description":"am","button":"an"};